// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"345564fc","856":"6d4789f7"}[chunkId] + ".chunk.js";
};